// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutSharedStyles } from "@sc/App/SharedStyles/CheckoutSharedStyles";
import { paymentMethodStyles } from "@sc/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

paymentMethodStyles.title = {
    ...checkoutSharedStyles.sectionTitle,
};
paymentMethodStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 135px;
        row-gap: 24px;
    `,
};
paymentMethodStyles.paymentMethodWrapper = {
    css: css`
        width: calc((100% - 135px) / 2);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
paymentMethodStyles.poWrapper = {
    css: css`
        width: calc((100% - 135px) / 2);
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
